export class IntegrationsController {

	constructor($scope, IntegrationDao, XRayUIModelSaver, JFrogNotifications, JFrogGridFactory, JFrogModal,$rootScope) {
		this.integrationDao = IntegrationDao;
		$rootScope.h1Header='Integrations';
		this.JFrogNotifications = JFrogNotifications;
		this.jfrogGridFactory = JFrogGridFactory;
		this.modelSaver = XRayUIModelSaver.createInstance(this, ['whitesource', 'aqua']);
		this.$scope = $scope;
		this.modal = JFrogModal;
		$scope.$parent.Settings.showButtons = false;
		$scope.$parent.Settings.currentSubController = this;
		this._createGrid();
		this.getData();
		this.IntegrationTypes = ['aqua', 'whitesource', 'blackduck'];
		this['customXrayIntegration'] = {
			vendor: ''
		};
		this.integrationVendors = {
			aqua: {
				desc: 'Aqua provides full visibility and control over containerized environments, with tight runtime security controls and intrusion prevention capabilities, at any scale. More details at https://www.aquasec.com',
				displayName: 'Aqua',
				logo: './images/aqua.png',
				name: 'aqua'
			},
			whitesource: {
				desc: 'WhiteSource provides a simple yet powerful open source security and licenses management solution. More details at http://www.whitesourcesoftware.com',
				displayName: 'WhiteSource',
				logo: './images/whitesource.png',
				name: 'whitesource'
			},
			blackduck: {
				desc: 'Organizations worldwide use Black Duck’s industry-leading products to automate the process of securing and managing open source software, eliminating the pain related to security vulnerabilities, compliance and operational risk.',
				displayName: 'Black Duck',
				logo: './images/blackduck.jpg',
				name: 'blackduck'
			}
		};
        $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
        })
	}

	getData() {
		this.integrationDao.get().$promise.then((data) => {

			this.currentIntegrations = data;
			this.whitesource = _.find(data, {vendor: 'whitesource'}) || {vendor: 'whitesource'};
			if (!this.whitesource.description) {
				this.whitesource.description = 'WhiteSource provides a simple yet powerful open source security and licenses management solution. More details at http://www.whitesourcesoftware.com';
			}
			if (!this.whitesource.url) {
				this.whitesource.url = 'https://saas.whitesourcesoftware.com/xray';
			}
			if (!this.whitesource.test_url) {
				this.whitesource.test_url = 'https://saas.whitesourcesoftware.com/xray/api/checkauth';
			}
			this.aqua = _.find(data, {vendor: 'aqua'}) || {vendor: 'aqua'};
			if (!this.aqua.description) {
				this.aqua.description = 'Aqua provides full visibility and control over containerized environments, with tight runtime security controls and intrusion prevention capabilities, at any scale. More details at https://www.aquasec.com';
			}

			this.blackduck = _.find(data, {vendor: 'blackduck'}) || {vendor: 'blackduck'};
			this.blackduck.description = 'Organizations worldwide use Black Duck’s industry-leading products to automate the process of securing and managing open source software, eliminating the pain related to security vulnerabilities, compliance and operational risk.';


			this.availableVendors = _.map(data, 'vendor');


			this.vendorsToAdd = [];
			_.forEach(this.IntegrationTypes, (value, key) => {

				if (this.availableVendors.indexOf(value) < 0) {
					this.vendorsToAdd.push(value);
				}
			});
			_.forEach(data, (value, key) => {

				if (this.IntegrationTypes.indexOf(value.vendor) < 0) {
					this._addVendorToList(value);
				}
			});

			this.modelSaver.save();
			this.gridOptions.setGridData(data);

		});

	}


	save(vendor) {


		if (!this[vendor]) {
			return;
		}
		if (this.checkDelete(vendor)) {
			this.modelSaver.save(vendor);
			return;
		}

		this.integrationDao.addOrUpdate({}, this[vendor]).$promise.then((response) => {

			if (vendor === 'customXrayIntegration') {
				this._clearCustomVendorFields();
			}
			this.modelSaver.save(vendor);

			this.getData();


		});
	}

	_clearCustomVendorFields() {

		delete this['customXrayIntegration'].vendor;
		delete this['customXrayIntegration'].icon_path;
		delete this['customXrayIntegration'].api_key;
		delete this['customXrayIntegration'].url;
		delete this['customXrayIntegration'].test_url;
	}

	test(vendor) {
		if (!this[vendor]) {
			return;
		}
		this.integrationDao.validate({}, this[vendor]).$promise.then((response) => {

		});
	}

	checkDelete(vendor) {
		let deleteFlag = false;
		switch (vendor) {
			case 'aqua':
				if (this[vendor].api_key === '' && this[vendor].url === '') {
					deleteFlag = true;
				}
				break;
			case 'whitesource' :

				if (this[vendor].api_key === '') {
					deleteFlag = true;
				}
				break;

			case 'blackduck' :

				if (this[vendor].api_key === '') {
					deleteFlag = true;
				}
				break;



		}
		if (deleteFlag) {
			this.integrationDao.delete({}, {vendorToDelete: vendor}).$promise.then((response) => {
				this.getData();
				this.modelSaver.save(vendor);

				switch (vendor) {

					case 'whitesource':

						this.wsClass = '';
						break;

					case 'aqua':

						this.aquaClass = '';
						break;

					case 'blackduck':

						this.blackduckClass = '';
						break;

				}
			});
		}
		return deleteFlag;
	}


	/* Grid new section */

	_createGrid() {
		this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
		                       .setRowTemplate('default')
		                       .setColumns(this._getColumns())
		                       /*
								.setMultiSelect()
								*/
		                       .setButtons(this._getActions());
		//            .setBatchActions(this._getAlertsBatchActions());
	}

	_addVendorToList(value) {
		let obj = {};

		obj.desc = value.description;
		obj.name = value.vendor;
		obj.displayName = value.vendor;
		obj.logo = './images/custom_integration.svg';

		if (value.icon_path) {
			obj.logo = value.icon_path;
		}

		this.integrationVendors[value.vendor] = obj;

		let dataObj = {};

		dataObj.api_key = value.api_key;
		dataObj.vendor = value.vendor;
		dataObj.context = value.context;
		dataObj.description = value.description;
		dataObj.enabled = value.enabled;
		dataObj.url = value.url;
		dataObj.test_url = value.test_url;

		if (value.icon_path) {
			dataObj.icon_path = value.icon_path;
		}
		this[dataObj.vendor] = dataObj;

	}


	_getColumns() {
		return [
			{
				name: 'Name',
				displayName: 'Name',
				field: 'vendor',
				cellTemplate: `<div  ng-click="grid.appScope.Integrations.showModal(row.entity.vendor,'edit')"  class="ui-grid-cell-contents"><a class="integration-name">{{grid.appScope.Integrations.integrationVendors[row.entity.vendor].displayName}}</a></div>`,
				width: '15%',
				customActions: [{
					icon: 'icon icon-run',
					tooltip: 'Test Integration',
					callback: (row) => this.test(row.vendor),
					visibleWhen: (row) => {
						return (row.vendor === 'snyk' && row.is_premium) || row.vendor !== 'snyk';
					}
				}]
			},
			{
				name: 'Description',
				displayName: 'Description',
				field: 'description',
				cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.description}}</div>',
				width: '50%'
			},
			{
				name: 'URL',
				displayName: 'URL',
				field: 'url',
				cellTemplate: `<div class="ui-grid-cell-contents"><a target="_blank" ng-href="{{row.entity.url}}">{{row.entity.url}}</a></div>`,
				width: '25%'
			},
			{
				name: 'Enabled',
				displayName: 'Enabled',
				field: 'enabled',
				cellTemplate: `<div class="ui-grid-cell-contents enable-status" ng-class="row.entity.enabled ? 'icon-notif-success' : 'icon-notif-error'"></div>`,
				width: '15%'
			}
		];
	}

	_getActions() {
		return [

			{
				icon: 'icon-artifactory-edit',
				tooltip: 'Edit',
				callback: (row) => this.showModal(row.vendor, 'edit')
			},
			{
				icon: 'icon icon-clear',
				tooltip: 'Delete',
				callback: (row) => this.deleteIntegration(row)
			}


		];
	}


	deleteIntegration(row) {
		this.modal.confirm(
			`Are you sure you want to delete  '${this.integrationVendors[row.vendor].displayName}' integration ?`)
		    .then(() => {
			    this.integrationDao.delete({}, {vendorToDelete: row.vendor}).$promise.then((response) => {
				    if (row.vendor !== 'aqua' && row.vendor !== 'whitesource' && row.vendor !== 'blackduck') {
					    delete this.integrationVendors[row.vendor];
				    }
				    this.getData();
			    });

		    });
	}

	showModal(vendor, action) {

		this.currentActionState = action;
		let modalScope = this.$scope.$new();

		this.selectedVendor = vendor;
		if (this.currentActionState === 'edit') {
			modalScope.modalTitle = 'Edit Integration';
		}
		else {
			modalScope.modalTitle = 'Add Integration';
		}

		this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/add_new_integration_modal.html'), modalScope).result.then(() => {


		});
		this.checkIfExist();
	}

	checkIfExist(vendor = '') {


		if (vendor !== '') {
			return _.map(this.currentIntegrations, 'vendor').indexOf(vendor) > -1;
		}
		this.modalAPI = '';
		this.modalURL = '';
		this.modalEnable = false;
		this.modalStatus = 'add';
		_.forEach(this.currentIntegrations, (value, key) => {

			if (value.vendor === this.selectedVendor) {

				this.modalAPI = value.api_key;
				this.modalURL = value.url;
				this.modalEnable = value.enabled;
				this.modalStatus = 'edit';
			}


		});
	}


	selectIntegration(vendor) {
		this.selectedVendor = vendor;
	}

	getModalTitle() {

		if (_.map(this.currentIntegrations, 'vendor').indexOf(this.selectedVendor) > -1) {
			return 'Edit Integration';
		}
		return 'Add Integration';
	}

}





// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/integrations/integrations.controller.js